import React from 'react'
import { Grid } from 'semantic-ui-react';
import CountUp from 'react-countup';
class FiveBlockDivision extends React.Component {

    render() {
        return (
            <Grid className="count-block-item " >
                <Grid.Row columns="equal" className="five-block w-5/4">
                    <Grid.Column >
                        <div>
                            <CountUp end={this.props.intitiativeCountData.notStarted ? this.props.intitiativeCountData.notStarted : 0} duration={5} className="notStarted" />
                        </div>
                        <label className="no-cursor-pointer">Not Started</label>
                    </Grid.Column>
                    <Grid.Column >
                        <div>
                            <CountUp end={this.props.intitiativeCountData.inProgress ? this.props.intitiativeCountData.inProgress : 0} duration={5} className="inProgress" />
                        </div>
                        <label className="no-cursor-pointer">In Progress</label>
                    </Grid.Column>
                    <Grid.Column >
                        <div>
                            <CountUp end={this.props.intitiativeCountData.delayed ? this.props.intitiativeCountData.delayed : 0} duration={5} className="delayed" />
                        </div>
                        <label className="no-cursor-pointer">Delayed</label>
                    </Grid.Column>
                    <Grid.Column >
                        <div>
                            <CountUp end={this.props.intitiativeCountData.issue ? this.props.intitiativeCountData.issue : 0} duration={5} className="issue" />
                        </div>
                        <label className="no-cursor-pointer">Issue</label>
                    </Grid.Column>
                    <Grid.Column >
                        <div>
                            <CountUp end={this.props.intitiativeCountData.completed ? this.props.intitiativeCountData.completed : 0} duration={5} className="completed" />
                        </div>
                        <label className="no-cursor-pointer">Completed</label>
                    </Grid.Column>

                </Grid.Row>
            </Grid>
        )
    }
}

export default FiveBlockDivision;